import EF from 'ef/ef';

const AhoyService = {
  initialize: function () {},
  track: function (name, properties) {
    const defaults = {
      metadata: {
        progress_id: EF.enrollment.id,
        type: name,
        lang: EF.language,
      },
    };
    if (EF.module) {
      defaults.metadata.module = EF.module.attributes.key;
      if (EF.module.currentActivity) {
        defaults.metadata.activity = EF.module.currentActivity.attributes.key;
        if (EF.module.currentActivity.currentPage) {
          defaults.metadata.page = EF.module.currentActivity.currentPage.attributes.key;
        }
      }
    }
    const data = Object.assign({}, defaults, properties);
    window.ahoy?.default.track(name, data);
  },
};

export default AhoyService;
